'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Rainbow';

var EntypoRainbow = function EntypoRainbow(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,5C4.4771729,5,0,9.4771118,0,15h1.5c0-4.694458,3.8056641-8.5,8.5-8.5s8.5,3.805542,8.5,8.5H20C20,9.4771118,15.5228271,5,10,5z M10,11c-2.2092285,0-4,1.7908325-4,4h1.5c0-1.3807373,1.1192627-2.5,2.5-2.5s2.5,1.1192627,2.5,2.5H14C14,12.7908325,12.2092285,11,10,11z M10,8c-3.8659668,0-7,3.1339722-7,7h1.5c0-3.0375977,2.4624023-5.5,5.5-5.5s5.5,2.4624023,5.5,5.5H17C17,11.1339722,13.8659668,8,10,8z' })
    );
};

exports.default = EntypoRainbow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/Rainbow.js
// module id = 724
// module chunks = 168707334958949